export const userConstants = {
    FETCH: 'FETCH',
    USERS: 'USERS',
    USER: 'USER',
    NEW_USER: 'NEW_USER',
    UPDATE_USER: 'UPDATE_USER',
    DELETE_USER: 'DELETE_USER',
  };
  